import {IEnvironment} from "@environments/ienvironment";

export const environment: IEnvironment = {
    apiBaseUrl: "",
    accessBaseUrl: "https://access.recette.sightness.tech",
    cookieDomain: ".recette.sightness.tech",
    tokenReturnMethod: "c",
    production: false
};
